import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

interface FormFieldComponentProps {
    value: any;
    onChange: Function;
    isErrored?: boolean;
    placeholder?: string;
}

const PlanOfUseComponent = ({
    value,
    isErrored,
    onChange,
    placeholder = '',
}: FormFieldComponentProps) => (
    <div className="sid-field sid-plan-of-use">
        <div className="sid-l-space-top-md" />
        <label>
            <div className={`sid-field__label sid-field__label--required sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                <FormattedHTMLMessage
                    id="planOfUse"
                    defaultMessage="Plan of Use"
                />
            </div>
            <input
                className={
                    `sid-text-input sid-text-input--required
                        sid-l-full-width sid-hidden-placeholder ${isErrored ? 'sid-text-input--error' : ''}`
                }
                id="sid-plan-of-use"
                name="sid-plan-of-use"
                type="text"
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
            />
        </label>

        {
            isErrored ? (
                <div className="sid-field-error">
                    <FormattedHTMLMessage
                        id="errorId.invalidPlanOfUse"
                        defaultMessage="Invalid plan of use"
                    />
                </div>
            ) : null
        }
    </div>
);

export { PlanOfUseComponent };
